// extracted by mini-css-extract-plugin
export var collapsedSummary = "_lb-0";